export default defineNuxtRouteMiddleware(() => {
  const { user } = useSanctumAuth()

  // @ts-ignore
  if (user.value?.influencer?.verified_at) {
    return navigateTo('/influenciador/link-viral', { replace: true })
  }
})
